import { createActionConst } from '../../../utils/action.utils';

const SETTINGS_NAMESPACE = 'SETTINGS';

export const SEARCH_SETTINGSS = createActionConst(SETTINGS_NAMESPACE, 'SEARCH_SETTINGSS');

export const STORE_SETTINGS = createActionConst(SETTINGS_NAMESPACE, 'STORE_SETTINGS');
export const CLEAR_SETTINGS = createActionConst(SETTINGS_NAMESPACE, 'CLEAR_SETTINGS');
export const INTEGRATE_WRIKE = createActionConst(SETTINGS_NAMESPACE, 'INTEGRATE_WRIKE');
export const FETCH_WRIKE_FOLDERS = createActionConst(SETTINGS_NAMESPACE, 'FETCH_WRIKE_FOLDERS');
export const SYNC_WRIKE_FOLDERS = createActionConst(SETTINGS_NAMESPACE, 'SYNC_WRIKE_FOLDERS');
